import React from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {IconoirCustomEstimate} from '@ey/motif-react-wrapper/assets/icons/custom';
import {labels} from '../../../../../../../util/utils';
import {entities as EntityTypes, documentTypes, ViewKeys} from '../../../../../../../util/uiconstants';
import {setFormV2ToasterVisibility} from '../../../../../../../actions/toastactions';
import EllipsesControl from '../../../../../../Common/EllipsesControl/EllipsesControl';
import AccountExecutionType from '../../../../../Accounts/AccountExecutionType/AccountExecutionType';
import RelatedDocumentsTooltip from './RelatedDocumentsTooltip';
import CreateEntityForm from '../../../Common/CreateEntityForm/CreateEntityForm';

export default function AccountName(props) {
	const {name, relatedDocuments, hasEstimate, executionTypeId, createDocIfNotExist, accountId} = props;
	const dispatch = useDispatch();

	const handleCreateDocument = () => {
		dispatch(setFormV2ToasterVisibility(true, 'info', labels.documentCreationSuccessMsg));
	};

	return (
		<>
			{relatedDocuments && relatedDocuments.length > 0 ? (
				<RelatedDocumentsTooltip
					relatedDocuments={relatedDocuments}
					name={name}
					hasEstimate={hasEstimate}
					executionTypeId={executionTypeId}
					title={labels.ALRARelatedDocuments}
				/>
			) : createDocIfNotExist ? (
				<StyledAccountNameIsLink
					className={`StyledAccountNameIsLink ${executionTypeId ? 'executionVisible' : 'executionNotVisible'}`}
				>
					<CreateEntityForm
						key={`createEntityAccount-${accountId}`}
						createLabel={name}
						entityId={EntityTypes.Account}
						objectIds={[accountId]}
						documentTypeId={documentTypes.ALRA_INDIVIDUAL}
						viewKey={ViewKeys.Account}
						showIcon={false}
						showDocuments={false}
						showLoading={false}
						onCreateDocument={handleCreateDocument}
					/>
					<AccountExecutionType executionTypeId={executionTypeId} />
					{hasEstimate && (
						<MotifIcon
							className="medium estimate-icon"
							title={labels.estimate}
							iconFunction={IconoirCustomEstimate}
							size="24"
						/>
					)}
				</StyledAccountNameIsLink>
			) : (
				<StyledAccountName className="StyledAccountName">
					<span className="account-name">
						<EllipsesControl content={name} tooltip={name} noOfLines={1} />
					</span>
					{hasEstimate && (
						<MotifIcon
							className="medium estimate-icon"
							title={labels.estimate}
							iconFunction={IconoirCustomEstimate}
							size="24"
						/>
					)}
				</StyledAccountName>
			)}
		</>
	);
}

const StyledAccountNameIsLink = styled.section`
	display: flex;
	align-items: center;
	font-weight: 400;
	line-height: var(--px-14);
	font-size: var(--px-14);
	color: var(--blue-600);
	width: 100%;
	&:hover {
		.StyledCreateLabel {
			/*text-decoration: underline;*/
		}
		.executionTypeLabel {
			text-decoration: none;
		}
	}
	.StyledCreate {
		width: auto;
		max-width: calc(100% - var(--px-20));
		.StyledCreateLabel {
			width: 100%;
			font-weight: 400 !important;
		}
	}
	.account-name {
		display: inline-flex;
		justify-content: flex-start;
		width: auto;
		max-width: calc(100% - var(--px-20));
		&:hover {
			text-decoration: underline;
		}
	}
	.estimate-icon {
		justify-content: flex-end;
		margin-left: auto;
		color: var(--neutrals-900);
		svg {
			height: var(--px-24);
			width: var(--px-24);
			color: var(--neutrals-900);
			path {
				fill: currentColor;
			}
		}
	}
	.executionTypeLabel {
		color: var(--neutrals-900);
		text-decoration: none;
	}
	.StyledValidationCount {
		margin-left: var(--px-5);
	}
`;

const StyledAccountName = styled.section`
	display: flex;
	cursor: pointer;
	align-items: center;
	font-weight: 400;
	line-height: var(--px-14);
	font-size: var(--px-14);
	color: var(--blue-600);
	&:hover {
		text-decoration: underline;
	}
	.account-name {
		display: inline-flex;
		width: auto;
		max-width: calc(100% - var(--px-100));
		width: 100%;
		justify-content: flex-start;
	}
	.estimate-icon {
		justify-content: flex-end;
		margin-left: auto;
		color: var(--neutrals-900);
		svg {
			height: var(--px-24);
			width: var(--px-24);
			color: var(--neutrals-900);
			path {
				fill: currentColor;
			}
		}
	}
`;
